import { ResourceSelectInfo } from '@bookings/interfaces/booking';
import { Resource } from '@centers/interfaces/resource';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  name: 'bpc-resource-select',
  components: {},
})
export default class ResourceSelect extends Vue {
  @Prop(Array) readonly resourcesSelectInfo: ResourceSelectInfo[];

  formatPercent(value) {
    // TODO - Create Pipe
    const val = (value / 1).toFixed(2);
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  selectResource(resource: Resource) {
    this.$emit('resource-selected', resource);
  }

  formatDate(date): string {
    if (date) {
      return moment(String(date)).format('DD/MM/YYYY');
    }
    return '';
  }

  formatTime(time): string {
    if (time) {
      return time.substr(0, 5);
    }
    return '';
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
